import { useSelector } from 'react-redux';
import { ProjectId } from 'api/models';
import { Filter } from 'components/molecules/filters/types';
import { QueryCombinerType } from 'components/organisms/tasks/combiner';
import { BooleanField } from 'components/organisms/tasks/fields';
import { BooleanFilterOperationType } from 'components/organisms/tasks/filters/boolean';
import { getFilterFunction } from 'components/organisms/tasks/get-filter-function';
import { RootState } from 'data';
import { FieldsStore, TaskField } from 'stores/fields';
import { Task, TasksStore } from 'stores/tasks';

export const getTasksAtRiskFilter = (
  taskFields: Record<string, TaskField>,
): Filter => ({
  criteria: [taskFields.atRisk as BooleanField]
    .filter(Boolean)
    .map((field) => ({ field, type: BooleanFilterOperationType.IsTrue })),
  type: QueryCombinerType.All,
});

export const useTasksAtRisk = (projectId: number): Task[] => {
  const tasksStore = useSelector(({ tasks_v2 }: RootState) => tasks_v2);
  const tasks =
    TasksStore.ofProjectId(ProjectId(projectId))(tasksStore)[1] ?? [];
  const fieldsStore = useSelector(({ fields }: RootState) => fields);
  const task_fields: Record<string, TaskField> = {
    atRisk: FieldsStore.getTaskFieldByName('atRisk')(fieldsStore)[1],
  } as any;
  const filter = getFilterFunction(getTasksAtRiskFilter(task_fields));

  return tasks.filter((x) => filter?.(x as any) ?? true);
};
